<template>
  <div>
    <v-dialog
      v-model="isDialog"
      persistent
      max-width="60vw"
    >
      <v-card class="bankReconConfirmationDialog">
        <v-card-title>
          Would you like to create Bank Reconciliation records with Sai Monthly checked?
        </v-card-title>
        <v-card-text>
          <v-btn
            color="blue darken-1"
            text
            @click="gatherInfo('yes')"
          >
            Yes
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="gatherInfo('no')"
          >
            No
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'GatherInfoConfimationDialog',
  components: {
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    criteria: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
  }),
  created() {
  },
  computed: {
    isDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('dialogVal', value);
      },
    },
  },
  methods: {
    ...mapActions('glDaily/saiBankReconciliation', [
      'saiBankReconGatherInformation',
    ]),
    close() {
      this.isDialog = false;
    },
    handleLoadCRUDList() {
      this.$emit('loadCRUDList');
    },
    async gatherInfo(val) {
      const { fiscalYear, asOfDate } = this.criteria;
      if (val === 'yes') {
        await this.saiBankReconGatherInformation({
          criteria: {
            asOfDate,
            fiscalYear,
            checkSaiMonthly: true,
          },
        });
      } else {
        await this.saiBankReconGatherInformation({
          criteria: {
            asOfDate,
            fiscalYear,
          },
        });
      }
      this.close();
      this.handleLoadCRUDList();
    },
  },
};
</script>
